module.exports = __webpack_public_path__ + "assets/img/4.76442d3d.jpg";